import { FormDrawer, FormDrawerContent, SingleSelectField } from "@dgs/core";
import { FC } from "react";
import { useTranslation } from "react-i18next";
import { IEventContactIndexResource, allContactStatus } from "../../../shared/types";

interface Props {
	open: boolean;
	contact: IEventContactIndexResource;
	onClose: () => void;
	onClosed: () => void;
	onSubmit: (status: string | null) => Promise<boolean>;
}

export const StatusDrawer: FC<Props> = ({ contact, onSubmit, ...drawerProps }) => {
	const { t } = useTranslation();

	return (
		<FormDrawer
			title={t("Update contact status")}
			renderForm={(props) => (
				<FormDrawerContent {...props}>
					<SingleSelectField
						name="status"
						label={t("Status")}
						options={allContactStatus}
						getLabel={(status) => t(status)}
						clearable={true}
					/>
				</FormDrawerContent>
			)}
			initialValues={{ status: contact.status }}
			onSubmit={({ status }) => onSubmit(status)}
			{...drawerProps}
		/>
	);
};
